import { Folder, LampDesk, type LucideIcon } from 'lucide-react';
import { CONCEPT_ICONS } from './concept-icons';
import { isDeskNotesPath } from './desk-notes-location';

export type DeskMobileNavView = 'home' | 'all' | 'shared-with-me' | 'notes';

export const DESK_MOBILE_NAV_VIEWS: readonly DeskMobileNavView[] = [
  'home',
  'all',
  'shared-with-me',
  'notes',
] as const;

export function isDeskMobileNavView(view: string): view is DeskMobileNavView {
  return (DESK_MOBILE_NAV_VIEWS as readonly string[]).includes(view);
}

export type DeskPrimaryNavItem = {
  to: string;
  labelKey: string;
  fallbackLabel: string;
  icon: LucideIcon;
  isActive: (pathname: string) => boolean;
};

export const DESK_PRIMARY_NAV_ITEMS: DeskPrimaryNavItem[] = [
  {
    to: '/desk',
    labelKey: 'desk',
    fallbackLabel: 'Desk',
    icon: LampDesk,
    isActive: (pathname) => pathname === '/desk',
  },
  {
    to: '/projects',
    labelKey: 'Projects',
    fallbackLabel: 'Projects',
    icon: Folder,
    isActive: (pathname) => pathname === '/projects' || pathname === '/desk/import',
  },
  {
    to: '/desk/shared-with-me',
    labelKey: 'shared_with_me',
    fallbackLabel: 'Shared with me',
    icon: CONCEPT_ICONS.share,
    isActive: (pathname) => pathname === '/desk/shared-with-me',
  },
  {
    to: '/desk/notes',
    labelKey: 'Notes',
    fallbackLabel: 'Notes',
    icon: CONCEPT_ICONS.note,
    isActive: (pathname) => isDeskNotesPath(pathname),
  },
];
